import { Injectable } from '@angular/core';

@Injectable()
export class DebuglogService {

  message:string [];

  constructor(
  ) {
    this.message = [];
  }

  reset(){
    this.message = [];
  }

  setLog(text) {
    console.log(text);
//    this.message.push(`${new Date().toLocaleString()} : ${JSON.stringify(text)}`);
  }

  getLog(){
    return this.message;
  }
}



// WEBPACK FOOTER //
// ./src/providers/debuglog.service.ts